import { put, takeEvery } from "@redux-saga/core/effects";
import {
  handleNotificationAlertCatch,
  handleNotificationAlertTrySelect,
} from "common/method/handleNotificationAlert";
import AxiosCustom from "../../../common/components/apiConfig";

export const actionTypes = {
  selectCourses: "selectCourses [Action]",
  selectCoursesLoad: "selectCoursesLoad [Action]",
  selectCoursesAsync: "selectCoursesAsync [Action]",
  selectCourseDetails: "[selectCourseDetails] Action",
  selectCourseDetailsAsync: "[selectCourseDetailsAsync] Action",
};

const initialState = {
  data: [],
  details: null,
  loading: false,
};

export const select_courses_reducer = (
  state = initialState,
  { type, payload }
) => {
  switch (type) {
    case actionTypes.selectCourses:
      return {
        ...state,
        data: payload?.data ? payload?.data : [],
      };

    case actionTypes.selectCourseDetails:
      return {
        ...state,
        details: payload?.data ?? null,
      };

    case actionTypes.selectCoursesLoad:
      return {
        ...state,
        loading: payload,
      };
    default:
      return state;
  }
};

function* handleWorker({ payload }) {
  yield put({
    type: actionTypes.selectCoursesLoad,
    payload: true,
  });
  let config = {
    url: "select_request",
  };

  let data = {
    table: "GIFT",
    method_type: "select_courses",
    data: payload?.data ? payload?.data : {},
    sort_by: {},
    size: "50",
    from: "0",
  };

  try {
    let res = yield AxiosCustom(config, data);
    let isOk = handleNotificationAlertTrySelect(res);
    yield put({
      type: actionTypes.selectCourses,
      payload: res.data.response,
    });
  } catch {
    handleNotificationAlertCatch();
    // yield put({ type: actionTypes.creaditSelectLoad, payload: false });
  } finally {
    yield put({
      type: actionTypes.selectCoursesLoad,
      payload: false,
    });
  }
}

function* handleWorkerDetails({ payload }) {
  yield put({
    type: actionTypes.selectCoursesLoad,
    payload: true,
  });

  const config = { url: "select_request" };
  const data = {
    table: "GIFT",
    method_type: "select_courses",
    data: payload || {}, // ID or filters sent here
    sort_by: {},
    size: "50",
    from: "0",
  };

  try {
    let res = yield AxiosCustom(config, data);
    handleNotificationAlertTrySelect(res);

    yield put({
      type: actionTypes.selectCourseDetails,
      payload: res.data.response,
    });
  } catch (err) {
    handleNotificationAlertCatch();
  } finally {
    yield put({
      type: actionTypes.selectCoursesLoad,
      payload: false,
    });
  }
}

export function* selectCourses() {
  yield takeEvery(actionTypes.selectCoursesAsync, handleWorker);
  yield takeEvery(actionTypes.selectCourseDetailsAsync, handleWorkerDetails);
}
